export default "__VITE_ASSET__DO6YXAQ3__"